import * as Yup from "yup";

import dayjs from "dayjs";
import "dayjs/locale/pt-br";
dayjs.locale("pt-br");

export const newEdition = Yup.object().shape({
    nome: Yup.string()
        .required("O nome da edição é obrigatório")
        .max(50, "O nome deve ter no máximo 50 letras")
        .min(3, "O nome deve ter no mínimo 3 letras"),

    notaCorte: Yup.number()
        .nullable()
        .transform((value, originalValue) =>
            String(originalValue).trim() === "" ? null : value
        )
        .min(0, "A nota não pode ser menor que 0.0")
        .max(10, "A nota não pode ser maior que 10.0"),

    dataAberturaInscricao: Yup.date()
        .nullable()
        .transform((value, originalValue) =>
            String(originalValue).trim() === "" ? null : value
        )
        .typeError("A data de início das inscrições deve ser válida")
        .test(
            "data-no-passado",
            "A data de início deve ser no presente ou no futuro",
            (value) => {
            if (!value) return true;
            return dayjs(value).diff(dayjs(), "minute") >= 0;
            }
        )
        .test(
            "hora-adiantada",
            "Se o agendamento for para hoje, a hora deve ser pelo menos 1h à frente",
            (value) => {
            if (!value) return true;
            const agendamento = dayjs(value);
            const now = dayjs();
            const hoje = now.isSame(agendamento, "day");
            if (hoje) {
                return agendamento.isAfter(now.add(1, "hour"));
            }
            return true;
            }
        ),

    dataFimInscricao: Yup.date()
        .nullable()
        .transform((value, originalValue) =>
            String(originalValue).trim() === "" ? null : value
        )
        .typeError("A data de início das inscrições deve ser válida")
        .min(
            Yup.ref("dataAberturaInscricao"),
            "A data de fim deve ser posterior à de início"
        ),
})